<template>
    <div class="site-panel">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab no-border">
                <v-row class="no-frame">
                    <c-site-contact-column
                        title      = "Ansprechpartner Kunde"
                        :contacts  = "site.contacts.customer"
                        :company   = "customer"
                        :company-role = "Company.roles.customer"
                        @dissolve  = "onDissolve"
                        @assigned  = "onAssigned"
                        :key       = "refresh.customer"
                    />
                </v-row>
            </v-col>
            <v-col class="main-middlle-col modal-tab no-border">
                <v-row class="no-frame">
                    <c-site-contact-column
                        title      = "Ansprechpartner vor Ort"
                        :contacts  = "site.contacts.onSite"
                        :company   = "customer"
                        :company-role = "Company.roles.facilitymanagement"
                        :onsite    = "true"
                        @dissolve  = "onDissolve"
                        @assigned  = "onAssigned"
                        :key       = "refresh.onSite"
                    />
                </v-row>
            </v-col>
            <v-col class="main-middlle-col modal-tab no-border">
                <v-row class="no-frame">
                    <c-flip-card
                        class="w-100"
                        :top="8"
                        :right="12"
                        color="white--text"
                        front-text="Wartungsnehmer"
                        back-text="Notrufnehmer"
                    >
                        <template v-slot:front>
                            <c-site-contact-column
                                class="white"
                                title      = "Kontakte Wartungsnehmer"
                                :contacts  = "site.contacts.maintenance"
                                :company   = "mntCompany"
                                :company-role = "Company.roles.maintenance"
                                @dissolve  = "onDissolve"
                                @assigned  = "onAssigned"
                                :key       = "refresh.maintenance"
                            />
                        </template>
                        <template v-slot:back>
                            <c-site-contact-column
                                class="white"
                                title      = "Kontakte Notrufnehmer"
                                :contacts  = "site.contacts.emc"
                                :company   = "emcCompany"
                                :company-role = "Company.roles.escalation"
                                :zus       = "false"
                                @dissolve  = "onDissolve"
                                @assigned  = "onAssigned"
                                :key       = "refresh.emc"
                            />
                        </template>
                    </c-flip-card>
                </v-row>
            </v-col>
            <v-col class="main-last-col modal-tab no-border" style="padding-right: 1px">
                <v-row class="no-frame">
                    <c-site-contact-column
                        title      = "Kontakte ZÜS"
                        :contacts  = "site.contacts.zus"
                        :company   = "zusCompany"
                        :company-role = "Company.roles.inspection"
                        :zus       = "true"
                        @dissolve  = "onDissolve"
                        @assigned  = "onAssigned"
                        :key       = "refresh.zus"
                    />
                </v-row>
            </v-col>
        </v-row>
        <v-divider />
    </div>
</template>

<script>

import Core               from "@/modules/core/service/Core";
import Contact            from "@/modules/msd/company/contact/service/Contact";
import CSiteContactColumn from "@/modules/msd/unit/components/dialog/CSiteContactColumn";
import CFlipCard from "@/modules/core/components/utils/CFlipCard.vue";
import Company from "@/modules/msd/company/common/service/Company";

export default {
    name: "SiteContacts",

    components: {
        CFlipCard,
        CSiteContactColumn,
    },

    props: {
        site: {
            contacts: {
                required: true,
                type    : Object,
                default : function () {
                    return {
                        contract   : null,
                        mntContract: null,
                        escContract: null,
                        zusContract: null
                    }
                }
            },
        },
    },

    data: () => ({
        edit    : false,
        selected: null,
        refresh: {
            customer   : 0,
            onSite     : 0,
            maintenance: 0,
            emc        : 0,
            zus        : 0,
        },
        responsibilities: null,
    }),

    computed: {
        Company() {
            return Company
        },
        customer () {
            return this.site.customer;
        } ,

        mntCompany () {
            if (!this.site.liftmanagement || !this.site.liftmanagement.mntContract) {
                return null;
            }

            return this.site.liftmanagement.mntContract.company;
        },

        emcCompany () {
            if (!this.site.liftmanagement || !this.site.liftmanagement.escContract) {
                return null;
            }

            return this.site.liftmanagement.escContract.company;
        },

        zusCompany () {
            if (!this.site.liftmanagement || !this.site.liftmanagement.zusContract) {
                return null;
            }

            return this.site.liftmanagement.zusContract.company;
        }
    },

    methods: {
        onDissolve (contact) {
            const query = this.$t('contact.dissolve.query');
            const text  = this.$t('contact.dissolve.text',[ contact.name, this.site.fabricNo, this.site.customer.name]);

            Core.message.confirm(this, query, text, Core.message.Default, (value => {
                if (value) {
                    Contact.dissolve(contact, this.site.id).then(() => {
                        Core.message.hint(this, "Kontakt wurde entfernt");
                        this.onContactChanged (contact, false);
                    })
                }
            }));
        },

        onAssigned (event) {
            if (!event.selected) {
                return;
            }

            event.selected.forEach(contact => {
                Contact.assign(contact, this.site).then(() => {
                    Core.message.hint(this, "Kontakt wurde hinzugefügt");
                    this.onContactChanged (contact, true);
                    event.contacts.splice(1, 0, contact);
                    this.refresh.customer++;
                    this.refresh.onSite++;
                    this.refresh.maintenance++;
                    this.refresh.zus++;
                    this.refresh.emc++;
                })
            })


            /*
            Contact.assign(event.contact, this.site.id).then(() => {
                Core.message.hint(this, "Kontakt wurde hinzugefügt");
                this.onContactChanged (event.contact, true);
            })

             */
        },

        onContactChanged (contact, added) {
            if (this.refreshView(this.site.contacts.customer, contact, added))  {
                this.refresh.customer++;
            } else if (this.refreshView(this.site.contacts.onSite, contact, added))  {
                this.refresh.onSite++;
            } else if (this.refreshView(this.site.contacts.maintenance, contact, added))  {
                this.refresh.maintenance++;
            } else if (this.refreshView(this.site.contacts.zus, contact, added))  {
                this.refresh.zus++;
            } else if (this.refreshView(this.site.contacts.emc, contact, added))  {
                this.refresh.emc++;
            }
        },

        refreshView (array, contact, added) {
            const index = array.findIndex (c => c.id === contact.id);
            console.log("refresh", index)
            if (index < 0) return false;

            if (!added) {
                array.splice(index, 1);
            }

            return true;
        },
    }
}
</script>

<style scoped>

</style>